import script from "./SafetySOSPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SafetySOSPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__